import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/table'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import base_url from '../../utils/getlink';
import { Button } from '@chakra-ui/button';
import { Input } from '@chakra-ui/input';
import styles from "./ProductsShow.module.css";
const getProducts = (page)=>{
  return axios({
    method:'get',
    url:`${base_url}/products/?page_no=${page}`
  })
}

const ProductsShow = () => {
  const [productData,setProductData]=useState([]);
  const [totalPages,setTotalPages]=useState(1);
  const [pageNo,setPageNo]=useState(1);
  useEffect(()=>{
    getProducts(pageNo).then((res)=>{
      console.log(res.data);
      setProductData(res.data.data);
      // totalPages=res.data.total_pages
      setTotalPages(res.data.total_pages);
    }).catch((err)=>{
      console.log(err);
      console.log("something went wrong.");
    });
    
  },[setProductData,pageNo])
  return (
    <div >
      <div>
        <br/>
        <Button onClick={()=>{if(pageNo<totalPages){setPageNo((pre)=>pre+1)}}} width="5vh">+</Button>
        <Input type="number" value={pageNo} onChange={(e)=>{setPageNo(Number(e.target.value))}} width="8vh" max={totalPages} readOnly/>/ <Input value={totalPages} readOnly width={"8vh"}/>
        <Button onClick={()=>{ if(pageNo>1){setPageNo((pre)=>pre-1)}}} width="5vh">-</Button>
        <br/>
      </div>
      <div className={styles.scrollBar}>
      <Table>
        <Thead>
          <Tr><Th>Id</Th>
          <Th>Title</Th><Th>Price</Th><Th>rating</Th><Th>service</Th>
          </Tr>
        </Thead>
        <Tbody>
          {productData.length>0&&productData.map((product)=>{
            return (
              <Tr key={product._id}><Td>{product._id}</Td>
            <Td>{product.title}</Td><Td>{product.price}</Td><Td>{product.rating}</Td><Td>{product.service}</Td>
          </Tr>
            )
          })}
        </Tbody>
      </Table>
      </div>
    </div>
  )
}

export default ProductsShow